import { render } from "./CardAdditionalGenerationCapacity.vue?vue&type=template&id=226e811c"
import script from "./CardAdditionalGenerationCapacity.vue?vue&type=script&lang=js"
export * from "./CardAdditionalGenerationCapacity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__